export default "__VITE_ASSET__7c9b2fc5__"